import React from 'react';
import PropTypes from 'prop-types';

import {BigCalendar, EventWrapper} from 'views/module';
import EventTile from './EventTile';
import MonthlyEventTile from './MonthlyEventTile';

import moment from 'moment';
import momentTZ from 'moment-timezone';

const CalendarDisplay = (props) => {
  const {rangeView, setRangeView, view, setView} = props;

  const events = props.events;
  const loadMonthlyEvents = props.loadMonthlyEvents;
  const openEvent = props.openEvent;
  const reload = props.reload;
  const viewingTimezone = props.viewingTimezone;
  const rescheduleEvent = props.rescheduleEvent;

  React.useEffect(() => {
    const monthsToCheck = [];
    if (rangeView) {
      let start = null;
      let end = null;
      if (view === 'month') {
        start = moment(rangeView.start).date(1);
        end = moment(rangeView.end).date(1);
      } else {
        start = moment(rangeView[0]).date(1);
        end = moment(rangeView[rangeView.length - 1]).date(1);
      }
      while (start.isSameOrBefore(end)) {
        monthsToCheck.push({year: start.year(), month: start.month()});
        start.add(1, 'M');
      }
    } else {
      const now = moment();
      monthsToCheck.push({year: now.year(), month: now.month()});

      const lastMonth = moment().subtract(1, 'M');
      monthsToCheck.push({year: lastMonth.year(), month: lastMonth.month()});

      const nextMonth = moment().add(1, 'M');
      monthsToCheck.push({year: nextMonth.year(), month: nextMonth.month()});
    }
    loadMonthlyEvents(monthsToCheck);
  }, [rangeView, view, reload]);


  const onRangeChange = (rangeView, view) => {
    setRangeView(rangeView);
    if (view) {
      setView(view);
    }
  };
  const onViewChange = (view) => {
    setView(view);
  };
  const onSelectEvent = (scheduleEvent, e) => {
    openEvent(scheduleEvent.event.eventRn, scheduleEvent.event);
  };
  const onEventDrop = ({event, start, end}) => {
    if (rescheduleEvent && view !== 'month') {
      const originalStart = moment(event.event.eventData.startTime).toISOString();
      const originalEnd = moment(event.event.eventData.endTime).toISOString();
      const newStart = moment(start).toISOString();
      const newEnd = moment(end).toISOString();

      if (originalStart !== newStart || originalEnd !== newEnd) {
        rescheduleEvent(event.event.eventRn, event.event, {
          startTime: newStart,
          endTime: newEnd,
          timezone: event.event.eventData.timezone || momentTZ.tz.guess(),
        });
      }
    }
  };

  const onEventResize = ({event, start, end}) => {
    if (rescheduleEvent && view !== 'month') {
      const originalStart = moment(event.event.eventData.startTime).toISOString();
      const originalEnd = moment(event.event.eventData.endTime).toISOString();
      const newStart = moment(start).toISOString();
      const newEnd = moment(end).toISOString();

      if (originalStart !== newStart || originalEnd !== newEnd) {
        rescheduleEvent(event.event.eventRn, event.event, {
          startTime: newStart,
          endTime: newEnd,
          timezone: event.event.eventData.timezone || momentTZ.tz.guess(),
        });
      }
    }
  };

  const eventsToDisplay = React.useCallback(() => {
    return events
        .map((event, index) => {
          const newEvent = {};
          newEvent.index = index;
          newEvent.start = moment(event.eventData.startTime).toDate();
          newEvent.end = moment(event.eventData.endTime).toDate();
          newEvent.title = event.info.title;
          newEvent.event = event;
          return newEvent;
        });
  }, [events]);

  const tooltipAccessor = (event) => {
    if (view === 'month') {
      const startTime = moment(event.start).format('h:mm:ssa'); ;
      const endTime = moment(event.end).format('h:mm:ssa'); ;
      return (`${startTime}-${endTime}: ${event.title}`);
    } else {
      return `${event.title}`;
    }
  };
  return (
    <BigCalendar
      events={eventsToDisplay()}
      showMultiDayTimes={true}
      defaultView={view}
      views={['month', 'week', 'day']}
      onRangeChange={onRangeChange}
      onView={onViewChange}
      onSelectEvent={onSelectEvent}
      onEventDrop={onEventDrop}
      onEventResize={onEventResize}
      timezone={viewingTimezone}
      tooltipAccessor={tooltipAccessor}
      draggableEvents={false}
      components={{
        event: view === 'month' ? MonthlyEventTile : EventTile,
        eventWrapper: EventWrapper,
      }}
    />
  );
};

CalendarDisplay.propTypes = {
  rangeView: PropTypes.any,
  setRangeView: PropTypes.func.isRequired,
  view: PropTypes.string.isRequired,
  setView: PropTypes.func.isRequired,
  events: PropTypes.array.isRequired,
  loadMonthlyEvents: PropTypes.func.isRequired,
  openEvent: PropTypes.func.isRequired,
  reload: PropTypes.number.isRequired,
  viewingTimezone: PropTypes.string.isRequired,
  rescheduleEvent: PropTypes.func,
};

export default React.memo(CalendarDisplay);
